import React, { useContext, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import MaskedInput from 'react-input-mask';
import { Row, Col, Card, Form, Input, Button, notification } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { storage } from 'helpers';
import { AuthContext } from 'context/AuthContext';
import merchService from 'services/merch.service';

const MerchEdit = (props) => {
  const [form] = Form.useForm();
  const context = useContext(AuthContext);
  const number = useParams()?.number;
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [setCurrentMerch] = useState(null);

  useEffect(() => {
    const selectedMerch = context?.currentUserMerchs?.find((merch) => merch.number === number); // Değişken adı değiştirildi
    setCurrentMerch(selectedMerch);
    form.setFieldsValue(selectedMerch);
  }, [context?.currentUserMerchs, number, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const selectedMerch = context?.currentUserMerchs?.find((merch) => merch.number === number);
      const { updateCurrentUser, selectedMerch: contextSelectedMerch } = context;

      setSubmitting(true);
      const body = { ...values };
      await merchService.updateMerch(selectedMerch.identifier, body);
      updateCurrentUser();

      notification.success({
        message: 'İşlem Başarılı',
        description: 'Üye işyeri güncellendi.',
      });

      if (selectedMerch.identifier === contextSelectedMerch.identifier) {
        storage.set({ ...contextSelectedMerch, ...values }, 'selectedMerch');
      }

      setSubmitting(false);
    } catch (error) {
      notification.error({
        message: 'İşlem Başarısız',
        description: error.message || 'Bir hata oluştu.',
      });
      setSubmitting(false);
    }
  };

  return (
    <PageContainer title={`${number} - İş Yeri Bilgileri Düzenleme`} onBack={() => navigate(-1)}>
      <Row gutter={[20, 20]}>
        <Col span={12}>
          <Form form={form} name="infoForm" onFinish={handleSubmit} layout="vertical">
            <Card type="inner" title="İş Yeri Bilgileri">
              <Form.Item
                name="contactName"
                label="Yetkili Kişi"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="Yetkili Kişi" />
              </Form.Item>
              <Form.Item
                name="email"
                label="İletişim Mail Adresi"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="ornek@mail.com" />
              </Form.Item>
              <Form.Item
                name="emailForArchive"
                label="E-Arşiv Mail Adresi"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="ornek@mail.com" />
              </Form.Item>
              <Form.Item
                name="contactEmail"
                label="Muhasebe Yetkilisi E-Posta Adresi"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="ornek@mail.com" />
              </Form.Item>
              <Form.Item
                name="contactGsm"
                label="GSM Numarası"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <MaskedInput mask="(999) 999-99-99">
                  {() => <Input className="input__default" placeholder="GSM Numarası" />}
                </MaskedInput>
              </Form.Item>
              <Form.Item
                name="merchNumber"
                label="İş Yeri Numarası"
                rules={[{ required: true, message: 'Zorunlu Alan' }]}
              >
                <Input className="input__default" placeholder="0123456789" />
              </Form.Item>

              <Form.Item className="text-align-right">
                <Button
                  className="button button__fill"
                  type="primary"
                  htmlType="submit"
                  disabled={submitting}
                  loading={submitting}
                >
                  Kaydet
                </Button>
              </Form.Item>
            </Card>
          </Form>
        </Col>
      </Row>
    </PageContainer>
  );
};

export default MerchEdit;
